// Copyright (c) Docugami, Inc. All rights reserved.

import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { AppState } from "store";
import { getExtractionModel as getStoredExtractionModel, setExtractionModel as setStoredExtractionModel } from "utils/localStorageHelpers";
import { DEFAULT_EXTRACTION_MODEL, ExtractionModel, ExtractionSettings } from "./types";

const initialState: ExtractionSettings = {
    selectedModel: getStoredExtractionModel() ?? DEFAULT_EXTRACTION_MODEL
};

export const extractionSlice = createSlice({
    name: "extraction",
    initialState,
    reducers: {
        setExtractionModel: (state, action: PayloadAction<ExtractionModel>) => {
            state.selectedModel = action.payload;
            setStoredExtractionModel(action.payload);
        }
    }
});

export const { setExtractionModel } = extractionSlice.actions;

export const selectExtractionModel = (state: AppState): ExtractionModel =>
    state.extraction.selectedModel;

export default extractionSlice.reducer;
